export default {
      id: "qr-code-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#qr-code",
      toString: function () {
        return this.url;
      }
    }